import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { showErrorToast, showSuccessToast } from '../ButterToasts';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { SUBMIT_COMMENTS } from '../../../Utils/mixpanel/mixpanelEvents';
import * as Error from '../../utils/error';
import * as CommentsActions from '../../actions/comments';
import * as CommentsSelectors from '../../selectors/comments';
import * as FilesSelectors from '../../selectors/files';
import * as CurrentsSelectors from '../../selectors/current';
import * as SettingsSelectors from '../../selectors/settings';
import * as Translations from '../../providers/i18n';

import './style.scss';

class CommentsSummaryToSubmitModalFooter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.createComments = this.createComments.bind(this);
    }

    createComments() {
        const {
            pendingComments,
            commentsSummaryMessage,
            numberOfFiles,
            userId,
            source
        } = this.props;

        const payload = {
            comments: pendingComments,
            reviewType: 'REVISION',
            reviewMessage: commentsSummaryMessage
        };

        sendMixPanelEvent({
            eventName: SUBMIT_COMMENTS,
            eventData: {
                'Number of Comments': pendingComments.length,
                'Number of Files': numberOfFiles,
                'Is Collaborator': !userId,
                'Related Flow': source
            }
        });

        return this.props.createComments(payload);
    }

    handleSuccess() {
        this.setState({
            isLoading: false
        });

        const {
            close,
            i18n
        } = this.props;

        close();
        showSuccessToast(i18n.t('attachments_preview.collaboration.toasts.review_submited'));
    }

    handleError(error) {
        this.setState({
            isLoading: false
        });

        const { i18n } = this.props;

        Error.send(error, 'CommentsSummaryToSubmitModalComponents');
        showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
    }

    handleClick(e) {
        e.preventDefault();

        this.setState({
            isLoading: true
        });

        this.createComments()
            .then(this.handleSuccess)
            .catch(this.handleError);
    }

    render() {
        const { i18n } = this.props;

        const className = classnames('comments-summary-modal-footer-btn', {
            loading: this.state.isLoading
        });

        const trimmedMessage = this.props.commentsSummaryMessage.trim();

        const disabled = this.state.isLoading || !trimmedMessage;

        return (
            <Button onClick={this.handleClick}
                className={className}
                disabled={disabled}>
                {i18n.t('attachments_preview.comments_summary_modal.button')}
            </Button>
        );
    }
}

CommentsSummaryToSubmitModalFooter.propTypes = {
    createComments: PropTypes.func,
    pendingComments: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        collaboratorId: PropTypes.string,
        body: PropTypes.string,
        timecode: PropTypes.number,
        annotations: PropTypes.array,
        groupId: PropTypes.string,
        fileId: PropTypes.string,
        createdAt: PropTypes.number
    })),
    commentsSummaryMessage: PropTypes.string,
    close: PropTypes.func,
    numberOfFiles: PropTypes.number,
    userId: PropTypes.number,
    source: PropTypes.string,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

CommentsSummaryToSubmitModalFooter.defaultProps = {
    close: Function.prototype,
    createComments: Function.prototype,
    pendingComments: []
};

const mapStateToProps = (state) => ({
    pendingComments: CommentsSelectors.getPendingComments(state),
    numberOfFiles: FilesSelectors.getFilesCount(state),
    userId: CurrentsSelectors.getCurrentUserId(state),
    source: SettingsSelectors.getSource(state)
});

const mapDispatchToProps = {
    createComments: CommentsActions.createComments
};

export default compose(
    Translations.connect,
    connect(mapStateToProps, mapDispatchToProps))(CommentsSummaryToSubmitModalFooter);
